/**
 * Created by Jie Gao on 2019-05-20.
 */

import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {ScatterWinView} from "./ScatterWinView";

export class ScatterWin extends WinPresentationController {
    private _view:ScatterWinView;

    private _fsTriggered:boolean;
    private _timeline:TimelineLite | null;
    private _animationTimeline:TimelineLite | null;
    private _reels:string[][];

    constructor(indexes:[number, number]) {
        super(indexes, {
            name : "ScatterWin",
            skippable : true
        });
        this._view = new ScatterWinView();
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        this._fsTriggered = data.freespinTriggeredThisSpin;
        if(this.hasWin()) {
            this._reels = data.reels;
        }
    }

    protected hasWin():boolean {
        return this._fsTriggered;
    }

    protected startWinPresentation():void {
        const tl:TimelineLite = new TimelineLite({paused : true});
        this._reels.forEach((reel:string[], reelId:number) => {
            reel.forEach((symbol:string, symId:number) => {
                if(symbol === ReelSymbolName.SCATTER) {
                    const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, symId);
                    if(scatter == null) {
                        debugger;
                        throw new Error(`ScatterWin.startWinPresentation(), scatter at reelId ${reelId}, symbolId ${symId} is null!`);
                    }
                    // const positionSymId:number = 6 - reel.length + symId;
                    tl.add(this._view.getScatterWinAnimation(reelId, symId, scatter), 0);
                }
            });
        });


        tl.add(() => {
            SlotGame.sound.playEffect(DragonTribeSoundConfig.SCATTER_WIN);
        }, 0);
        this._animationTimeline = tl;
        this._timeline = new TimelineLite();
        this._timeline.add(() => this._animationTimeline!.play());
        this._timeline.add(() => this.finish(), tl.totalDuration() + 0.5);
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
        }
        this._timeline = null;
        if(this._animationTimeline) {
            if(this._animationTimeline.progress() === 0) {
                this._animationTimeline.play();
            }
            if(this._animationTimeline.isActive()) {
                this._animationTimeline.progress(1);
                this._animationTimeline.kill();
            }
            this._animationTimeline = null;
        }
    }
}